export default {
  url: "",
  method: "GET",
  dataType: "json",
  beforeSend: (xhr, request) =>
    xhr.setRequestHeader("X-WP-Nonce", docketData.nonce),
  complete: (xhr) => {
    // update nonce
    var returnedNonce = xhr.getResponseHeader("X-WP-Nonce");
    if (returnedNonce && docketData.nonce !== returnedNonce) {
      docketData.nonce = returnedNonce;
    }
  },
};
